import { tt } from './i18n'
import { formatCents } from './money'

/**
 * *QR Pay* beside *CardPay online*, everywhere CardPay online is counted, always - FRONTEND.md §9.767, owner O129.
 *
 * **The owner**: *"everywhere we see "QRPay" the same way as "CardPay", we need to differ them ... add it in sumáre,
 * analytika, prehľad.. basically everywhere, where you can find Cardpay Online calculactions"*.
 *
 * **This replaces §9.741's rule**, which drew the QR Pay line *wherever it holds money, and only there* - `drawsQrPay`,
 * `cents > 0`, asked by seventeen surfaces - so on a day, a person or a period with no door QR payment the line was
 * not on the screen and the owner read that as QR Pay not being there. A nought is a fact about the day, as the other
 * method tiles always were, so the line is drawn whatever it holds. `qr-pay-beside-cardpay-online.test.ts` in the
 * manager holds every surface to it: no file asks the old rule, no line compares a QR figure with nought, and every
 * file that names CardPay online names QR Pay too.
 *
 * **One name for the online card.** It had six - *Online*, *CardPay*, *CardPay Online*, *CardPay (online)*, *Karta
 * online*, *Online platba* - against the badge's *CardPay online* (§9.204). Every screen asks these two functions, so a
 * seventh cannot appear without the guard naming the file.
 */

/** The online card's one name - the badge's word (§9.204). A brand name, through `tt()` like every other label. */
export function cardPayOnlineLabel(): string {
  return tt('CardPay online')
}

/** A door QR payment - §10A.390, the owner's word. */
export function qrPayLabel(): string {
  return tt('QR Pay')
}

/**
 * A QR Pay figure as a screen draws it: the amount, **nought included**, or *neevidované* for `null` - FRONTEND.md
 * §9.767.
 *
 * **Null is a figure that was never recorded, and it is not a nought.** A handover record from before QR Pay was
 * separated (`revenue_handovers.qr_pay_total`, `V85`, not back-filled) took no QR off at all - its QR money, if any, is
 * inside its CardPay online figure - so *0,00 €* there would claim the day was checked for QR and none was found.
 * Takes cents, because every caller has already parsed the server's money string.
 */
export function qrPayFigure(cents: number | null): string {
  return cents === null ? tt('neevidované') : formatCents(cents)
}
